/* RovoSearchHeader.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2mHwu8NHnM%7Bgap%3Avar(--ds-space-300%2C24px)%7D%0A._3SamIHNHnM%7Bmargin-block%3Avar(--ds-space-300%2C24px)%7D%0A._4c065U2ADO%7Bpadding-block%3Avar(--ds-space-100%2C8px)%7D%0A._3iDTPbQ4SZ%7Bdisplay%3Aflex%7D%0A._0aFT5vbt8w%7Bflex-direction%3Acolumn%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D");





import React from 'react';
import Heading from '@atlaskit/heading/heading';
import { Box } from '@atlaskit/primitives/compiled/box';
import { FormattedMessage, defineMessage } from 'react-intl';
import { RovoSearchHeaderIllustration } from './RovoSearchHeaderIllustration';
const rovoSearchHeaderSearchPageHeaderMessage = defineMessage({
  id: 'townsquare.search.page.header',
  defaultMessage: 'All your apps, one search',
  description: 'Refreshed search page header text. Used in the search header below the spotlight icon.'
});
const styles = {
  container: "_2mHwu8NHnM _3SamIHNHnM _4c065U2ADO _3iDTPbQ4SZ _0aFT5vbt8w _0hPCNLDIqT"
};
export const RovoSearchHeader = (): React.JSX.Element => {
  return <Box xcss={styles.container}>
			<RovoSearchHeaderIllustration size={82} testId="rovo-search-header-illustration" />
			<Heading size="xxlarge">
				<FormattedMessage {...rovoSearchHeaderSearchPageHeaderMessage} />
			</Heading>
		</Box>;
};